import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./Translations/LenguageContext";

import "./App.css";
import "./AppMobile.css";

import ScrollToTop from "./Functions/ScrollToTop";
import MainFrameHome from "./Website/Home/MainFrameHome";

import Terms_And_Conditions from "./Policies/TermsConditions";
import Cookie_Policy from "./Policies/CookiesPolicy";
import Legal_Notes from "./Policies/LegalNotes";
import Privacy_Policy from "./Policies/PrivacyPolicy";
import ContactSales from "./Website/Contact/ContactSales";
// import ContactSales from "./Website/Contact/ContactSales";


const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<MainFrameHome />} />
    {/* <Route path="/contact/sales" element={<ContactSales />} /> */}
    <Route path="/waitlist" element={<ContactSales />} />

    {/* Policies */}
    <Route path="/privacy" element={<Privacy_Policy />} />
    <Route path="/terms-and-conditions" element={<Terms_And_Conditions />} />
    <Route path="/cookie-policy" element={<Cookie_Policy />} />
    <Route path="/legal-notes" element={<Legal_Notes />} />

  </Routes>
);

const ThemeController = () => {
  const location = useLocation();
  const [audioEnabled, setAudioEnabled] = useState(false);

  const unlockAudio = () => {
    if (audioEnabled) return;

    const audio = new Audio("/sound/click_sound.mp3");
    audio.volume = 0;

    audio.play()
      .then(() => setAudioEnabled(true))
      .catch(() => { });
  };


  useEffect(() => {
    unlockAudio()
    const root = window.document.documentElement;

    const isPlatform =
      location.pathname.startsWith("/e8console") ||
      location.pathname.startsWith("/google-callback") ||
      location.pathname.startsWith("/outlook-callback") ||
      location.pathname.startsWith("/onboarding") ||
      location.pathname.startsWith("/directories")

    root.removeAttribute("data-theme");

    if (!isPlatform) {
      root.setAttribute("data-theme", "light");
      return;
    }

    const applyTheme = () => {
      const savedTheme = localStorage.getItem("pe8-theme-preference");

      let themeToSet = savedTheme;

      if (!savedTheme || savedTheme === "system") {
        themeToSet = window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light";
      }

      root.setAttribute("data-theme", themeToSet);
    };

    applyTheme();

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleSystemChange = () => {
      const currentPref = localStorage.getItem("pe8-theme-preference");
      if (!currentPref || currentPref === "system") {
        applyTheme();
      }
    };

    mediaQuery.addEventListener("change", handleSystemChange);
    window.addEventListener("storage", applyTheme);

    return () => {
      mediaQuery.removeEventListener("change", handleSystemChange);
      window.removeEventListener("storage", applyTheme);
    };
  }, [location.pathname]);

  return null;
};

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <ThemeController />

          <ScrollToTop />
          <AppRoutes />
      </Router>
    </LanguageProvider>
  );
};

export default App;